import React from "react";
import TypeGeneralSurvey from "./Type/TypeGeneralSurvey";
import TypeLocalitySurvey from "./Type/TypeLocalitySurvey";
import TypePostSurvey from "./Type/TypePostSurvey";
import TypeDepartmentSurvey from "./Type/TypeDepartmentSurvey";
import TypeDestinationSurvey from "./Type/TypeDestinationSurvey";
import TypeTrends from "./Type/TypeTrends";
import TypeTrendsSite from "./Type/TypeTrendsSite";
import TypeTrendsPost from "./Type/TypeTrendsPost";
import TypeTrendsTime from "./Type/TypeTrendsTime";
import Loader from "../../../../components/Loader";

export default function TypeGraphWebexReport({ data, people, reportType, analyseType, setDataGraph, setFormattedHeader, filteredPosts, user }) {  
    return (
        <div className="statistics-report">
            {data && people && reportType ? (
                reportType === "Enquête générale" ? (
                    <TypeGeneralSurvey data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                ) : reportType === "Enquête par sites" ? (
                    <TypeLocalitySurvey data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                ) : reportType === "Enquête par poste" ? (
                    <TypePostSurvey data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user} />
                ) : reportType === "Enquête par département" ? (
                    <TypeDepartmentSurvey data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user} />
                ) : reportType === "Enquête par origine d'appels" ? (
                    <TypeDestinationSurvey data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                ) : reportType === "Analyse des tendances" ? (
                    <TypeTrends data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader}  filteredPosts={filteredPosts} user={user}/>
                ) : reportType === "Analyse des tendances par sites" ? (
                    <TypeTrendsSite data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                ) : reportType === "Analyse des tendances par postes" ? (
                    <TypeTrendsPost data={data} people={people} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                ): reportType === "Analyse temporelle (HH, JJ...)" && (
                    <TypeTrendsTime data={data} people={people} analyseType={analyseType} setDataGraph={setDataGraph} setFormattedHeader={setFormattedHeader} filteredPosts={filteredPosts} user={user}/>
                )
            ) : (
                <Loader/>
            )}
            
        </div>
    ) 
}
